export default "__VITE_ASSET__Mgw6V9I6__"